import { Match, Tournament, emptyPlayer } from "@/views/interfaces/entities";

const state = {
  update: false,
  tournament: <Tournament>{
    id: 0,
    name: '',
    size: 0,
    tournamentType: '',
    status: '', // started, ended, created, draft
    positions: [],
    totalRounds: 0,
    currentRound: 0,
    players: [],
    matchTime: 0,
    endMatch: 0,
    views: 0,
  },
  match: <Match>{
    parentId: -1,
    posLeft: { player: emptyPlayer, posIndex: -1 },
    posRight: { player: emptyPlayer, posIndex: -1 },
    disabled: true,
  },
  tournamentSocket: <WebSocket>undefined,

  trending: <Tournament[]>[],
  ended: <Tournament[]>[],
};

export default state;
